module.exports = __webpack_public_path__ + "static/media/loading.86f4ea10.gif";